<template>
  <div class="content content-fixed content-auth-alt">
    <div class="container ht-100p">
      <div
        v-if="mode == 0"
        class="ht-100p d-flex flex-column align-items-center justify-content-center"
      >
        <div class="wd-150 wd-sm-250 mg-b-30">
          <img src="/assets/svg/complete.svg" class="img-fluid" alt />
        </div>
        <h4 class="tx-20 tx-sm-24">Жин тонн мэдээлэл шалгах</h4>
        <p class="tx-color-03 mg-b-40">
          Та шалгах Тээврийн хэрэгслийн улсын дугаарыг оруулаад
          шалгах товчийг дарна уу.
        </p>

        <div v-if="latestTollReady">
          <table class="table table-bordered">
            <tbody>
              <tr>
                <th>Огноо</th>
                <td>{{ latestToll.date | moment("YYYY-MM-DD HH:mm") }}</td>
              </tr>
              <tr>
                <th>Улсын дугаар</th>
                <td>{{ latestToll.plate }}</td>
              </tr>
              <tr>
                <th>Гарц</th>
                <td>{{ latestToll.gartsInfo }}</td>
              </tr>
              <tr>
                <th>Жин тонн</th>
                <td>{{ latestToll.jinTon }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="tx-13 tx-lg-14 mg-b-40 wd-300 text-center">
          <div class="mg-b-10">
            <input
              v-model="code"
              maxlength="10"
              type="text"
              class="form-control"
              placeholder="Тээврийн хэрэгслийн улсын дугаар оруулна уу"
            />
          </div>
          <button
            v-if="mode == 0"
            type="button"
            @click="activate()"
            class="btn btn-primary d-inline-flex text-white align-items-center mg-l-auto"
          >
            Шалгах
          </button>
        </div>
      </div>

      <div
        v-else-if="mode == 1"
        class="ht-100p d-flex flex-column align-items-center justify-content-center"
      >
      <h4 class="tx-20 text-success tx-sm-24">Зөвшөөрөл</h4>
      <iframe :src="link" width="100%" height="600px" style="border: 1px" border="1"></iframe>
      
        <div class="tx-13 tx-lg-14 mg-b-40 wd-300 text-center"><br/>
          <button
            type="button"
            @click="mode = 0"
            class="btn btn-primary d-inline-flex text-white align-items-center mg-l-auto"
          >
            Дахин хайх
          </button>
        </div>
      </div>
    </div>
    <!-- container -->
  </div>
</template>

<script>
import { request } from "@/api/all";
import "element-ui/lib/theme-chalk/index.css";
import { Notification } from "element-ui";
import { localRead } from "@/libs/util";
import { mapActions } from "vuex";

const moment = require("moment");

export default {
  data() {
    return {
      code: "",
      regno: "",
      mode: 0,
      link: "",
      st2: "",
      st3: "",
      st4: "",
      latestTollReady: false,
      latestToll: {
        date: null,
        gartsInfo: null,
        id: null,
        jinTon: null,
        plate: null,
        tatsInfo: null
      }
    };
  },
  mounted(){
    let plate = this.$route.params.p;
    
    if(plate!="1"){
      this.code=plate;
      this.activate();
    }
  },
  methods: {
    ...mapActions(["handleLoading"]),
    
    activate() {
      this.latestTollReady = false;
      this.handleLoading({ isLoading: true });

      request({
        api: { method: "GET", url: "RoadPay/GetLastEntryToll" },
        params: {
          plateNo: this.code
        },
        store: this.$store,
      }).then((res) => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          console.log(res.latestToll);
          this.latestToll = res.latestToll;
          this.latestTollReady = true;
          // if (res.data != undefined) {
          //   this.mode = 1;
          //   this.link=res.data.requestTask.link;
          // }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/pages/auth.scss";
</style>
